<template>
  <div
    class="iframe-box"
    v-show="showIframe"
    v-loading="loading"
    element-loading-text="正在加载..."
  >
    <transition-group name="fade-transform" mode="out-in">
      <iframe
        v-show="iframeItem.iframeSrc === iframe.iframeSrc && isKeepAlive"
        v-for="iframe in iframeList"
        :key="'id:' + iframe.menuId"
        :src="iframe.iframeSrc"
        class="iframe-item"
        :id="'iframeId_' + iframe.menuId"
        @load="handleIframeLoad(iframeItem.iframeSrc === iframe.iframeSrc, 'iframeId_' + iframe.menuId)"
      />
      <iframe
        v-if="!isKeepAlive && iframeItem.iframeSrc"
        :src="iframeItem.iframeSrc"
        :key="iframeItem.iframeSrc"
        class="iframe-item"
        :id="'iframeId_' + iframeItem.menuId"
        @load="handleIframeLoad(true, 'iframeId_' + iframeItem.menuId)"
        frameborder="0"
      />
    </transition-group>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isKeepAlive: false,
      iframeItem: {
        iframeSrc: null,
        menuId: null
      },
      showIframe: true,
      loading: true // 是否在请求
    }
  },
  computed: {
    iframeList() {
      return this.$store.getters.iframeList.map(item => item.meta)
    }
  },
  watch: {
    $route: {
      handler(val) {
        // this.loading = false
        this.iframeItem = {
          iframeSrc: null,
          menuId: null
        }
        setTimeout(() => {
          if (val.meta?.iframeSrc) {
            this.iframeItem.iframeSrc = val.meta?.iframeSrc
            this.iframeItem.menuId = val.meta?.menuId
            this.showIframe = true
          } else {
            this.showIframe = false
          }

          if (val.meta?.iframeSrc && val.meta?.cache === "1") {
            this.isKeepAlive = true
            const isInIframeList = this.iframeList.some((item) => {
              return item.iframeSrc === this.iframeItem.iframeSrc
            })
            if (!isInIframeList) {
              // 打开加载动画
              this.loading = true
              this.$store.dispatch("tagsView/addIframeList", val)
            }
          } else {
          // 不需要缓存的链接
            this.isKeepAlive = false
            // 打开加载动画
            this.loading = true
          }
        }, 0)
      },
      immediate: true
    }
  },
  methods: {
    handleIframeLoad(bool, domId) {
      if (bool) {
        this.loading = false

        const iframe = document.getElementById(domId)
        iframe.contentWindow.postMessage({
          action: "globalData",
          data: {
            // token
            accessToken: this.$store.getters.accessToken,
            refreshToken: this.$store.getters.refreshToken,
            
            // 用户信息
            userInfo: this.$store.getters.userInfo, // 用户信息
            permissionList: this.$store.getters.permissionList, // 按钮和列表接口权限标识列表
            roleIdList: this.$store.getters.roleIdList // 含有的角色id列表
          }
        }, "*")
      }
    }
  }
}
</script>
<style scoped lang="scss">
.iframe-box {
  width: 100%;
  height: calc(100vh - #{$LayoutHeaderHeight} - #{$LayoutTagsHeight});

  .iframe-item {
    width: 100%;
    height: 100%;
  }
}
</style>
